import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setVadSiteAssessmentOptions } from '../store/options.actions'

export function* getVadSiteAssessmentOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getVadSiteAssessmentOptions])
    const { entity } = response
    yield put(setVadSiteAssessmentOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getVadSiteAssessmentOptions() error: ${e}`))
  }
}
export function* getVadSiteAssessmentOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getVadSiteAssessmentOptions)
}
